window.__palladiumCookie = {
    set: function (name, value, days) {
        var d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + d.toUTCString() + ";path=/;SameSite=Lax";
    },
    del: function (name) {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax";
    }
};

/*
 * Envoi automatique du formulaire de redirection vers la passerelle de paiement
 * (flux Redirect a champs signes : Redsys, Monetico...). Appele apres
 * l'initiation du paiement : l'acheteur ne clique qu'UNE fois sur « Payer ».
 * Les passerelles en redirection GET (CAWL, CA-CIB) n'ont pas de formulaire :
 * le checkout navigue directement vers l'URL renvoyee.
 * Defini ici (et non dans un fichier a part) pour ne pas ajouter une requete
 * globale a chaque page publique pour quinze lignes ; garde d'idempotence car
 * Bookings embarque le meme helper.
 */
// Charge (une seule fois) le script d'un moyen de paiement « dans la page » avant son init.
if (!window.pdEnsureScript) {
    window.pdEnsureScript = function (src) {
        if (!src) return Promise.resolve(true);
        window.__pdScripts = window.__pdScripts || {};
        if (window.__pdScripts[src]) return window.__pdScripts[src];
        window.__pdScripts[src] = new Promise(function (resolve, reject) {
            var s = document.createElement('script');
            s.src = src; s.async = true;
            s.onload = function () { resolve(true); };
            s.onerror = function () { delete window.__pdScripts[src]; reject(new Error('script ' + src)); };
            document.head.appendChild(s);
        });
        return window.__pdScripts[src];
    };
}

if (!window.pdSubmitPaymentForm) {
    window.pdSubmitPaymentForm = function (id) {
        try {
            var f = document.getElementById(id || 'redirect-payment-form');
            if (f && typeof f.submit === 'function') { f.submit(); return true; }
        } catch (e) { /* le bouton du formulaire reste utilisable en secours */ }
        return false;
    };
}
